import { gql } from '@apollo/client'

export const CREATE_BOOKMARK = gql`
  mutation CREATE_BOOKMARK($input: BookmarkCreateInput) {
    bookmarkCreate(input: $input) {
      ok
    }
  }
`

export const DELETE_BOOKMARK = gql`
  mutation DELETE_BOOKMARK($input: BookmarkCreateInput) {
    bookmarkDelete(input: $input) {
      ok
    }
  }
`
